import isPropValid from "@emotion/is-prop-valid";

/**
 * styled-components 5 filtered unknown props out of host elements on its own; 6 does
 * not, and forwards everything, which makes React warn about attributes like
 * `marginTop` or `hideOnMobile` on a div. This restores the old behaviour in one
 * place: host elements only get valid HTML attributes, custom components still get
 * everything.
 *
 * The long term answer is renaming those props with a `$` prefix, which styled-
 * components filters automatically - this keeps the app quiet until then.
 */
export const shouldForwardProp = (prop: string, elementToBeCreated: unknown) =>
    typeof elementToBeCreated === "string" ? isPropValid(prop) : true;

export default shouldForwardProp;
